import {COUPON_PROMOTION_ID_QUERY_KEY} from '../Coupons/useCouponPromotionIdFromQueryParams';

export const createUrlWithPreselectedSize = ({
  pathname,
  search,
  selectedCoupon,
}: {
  pathname: string;
  search?: string;
  selectedCoupon?: string;
}) => {
  const searchParams = [
    ...(search?.split('&') ?? []),
    ...(selectedCoupon
      ? [`${COUPON_PROMOTION_ID_QUERY_KEY}=${selectedCoupon}`]
      : []),
  ].join('&');

  return {
    pathname,
    search: searchParams,
  };
};
